const CouponSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 20 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M3.95643 6.37028L3.68041 9.40649C3.63953 9.85615 3.61892 10.0829 3.65634 10.2981C3.68977 10.4904 3.75655 10.6754 3.85397 10.8446C3.96342 11.0346 4.12519 11.1964 4.4469 11.5181L8.75981 15.831C9.41568 16.4868 9.74379 16.815 10.1231 16.9382C10.4579 17.047 10.819 17.0472 11.1538 16.9385C11.5343 16.8148 11.865 16.4845 12.525 15.8245L15.8249 12.5247C16.4849 11.8646 16.8144 11.5348 16.938 11.1542C17.0468 10.8195 17.0461 10.4587 16.9374 10.124C16.8137 9.74344 16.4847 9.41364 15.8247 8.75361L11.5224 4.45134C11.1978 4.1267 11.0354 3.96436 10.8445 3.85441C10.6754 3.757 10.4904 3.68993 10.2981 3.6565C10.081 3.61876 9.85231 3.63951 9.39509 3.68107L6.37025 3.95606C5.58294 4.02763 5.18905 4.06358 4.88099 4.23488C4.60938 4.38592 4.38548 4.60983 4.23444 4.88143C4.06399 5.18796 4.02843 5.57906 3.95758 6.35853L3.95643 6.37028Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09366 8.09357C8.4191 7.76813 8.4191 7.2405 8.09366 6.91506C7.76822 6.58962 7.24021 6.58962 6.91477 6.91506C6.58934 7.2405 6.58902 7.76801 6.91446 8.09345C7.2399 8.41888 7.76822 8.41901 8.09366 8.09357Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default CouponSvg;
